import React from 'react';
import PropTypes from 'prop-types';
import { TotalDivContainer, SummaryContent } from './TotalDiv.styles';

const TotalDivComponent = ({ course, totalAmount, subtotal, taxAmount }) => {
  return (
    <TotalDivContainer>
      <h4>Order summary</h4>

      <SummaryContent>
        <div className="summary-row">
          <span>Subtotal</span>

          <span className="italicSpan">
            ${course ? course.price.toFixed(2) : subtotal}
          </span>
        </div>

        <div className="tax-row">
          <span>Tax (NS 14%)</span>

          <span className="tax-amount">
            $
            {typeof taxAmount === 'number' && !isNaN(taxAmount)
              ? taxAmount.toFixed(2)
              : taxAmount}
          </span>
        </div>

        <span className="tax-span">Tax will be calculated at checkout</span>

        <div className="total-row">
          <span>
            <strong>Total</strong>
          </span>

          <span>
            <strong>
              {typeof totalAmount === 'number' && !isNaN(totalAmount)
                ? `$${totalAmount.toFixed(2)}`
                : `$${totalAmount}`}
            </strong>
          </span>
        </div>
      </SummaryContent>
    </TotalDivContainer>
  );
};

TotalDivComponent.propTypes = {
  course: PropTypes.shape({
    courseId: PropTypes.string,
    courseName: PropTypes.string,
    price: PropTypes.number,
    expiryDate: PropTypes.number,
  }),
  totalAmount: PropTypes.number,
  taxAmount: PropTypes.number,
  billingAddress: PropTypes.object,
  taxRate: PropTypes.arrayOf(
    PropTypes.shape({
      province: PropTypes.string,
      rate: PropTypes.number,
    })
  ),
  subtotal: PropTypes.string,
  setStep: PropTypes.func,
};

export default TotalDivComponent;
